/* Keep Customily image choices at the same readable size as the reference PDP. */
(() => {
  let scheduled = false;
  const setSquareSize = (element, size) => {
    if (!element) return;
    for (const property of ['width', 'min-width', 'max-width', 'height', 'min-height', 'max-height']) {
      if (element.style.getPropertyValue(property) !== size || element.style.getPropertyPriority(property) !== 'important') {
        element.style.setProperty(property, size, 'important');
      }
    }
  };
  const sync = () => {
    scheduled = false;
    const tileSize = window.innerWidth <= 749 ? 'calc((100vw - 56px) / 5)' : '76px';
    const imageSize = window.innerWidth <= 749 ? 'calc((100vw - 106px) / 5)' : '66px';
    document.querySelectorAll('.customily_sets-panel .customily-swatch').forEach((swatch) => {
      const label = swatch.querySelector('label');
      setSquareSize(swatch, tileSize);
      setSquareSize(label, tileSize);
      setSquareSize(label?.querySelector('.csh-image-container'), imageSize);
      setSquareSize(label?.querySelector('img'), imageSize);
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  };
  const init = () => {
    sync();
    window.HanossCustomilyCapabilities?.onPanelChange(sync);
    window.addEventListener('resize', schedule, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
